import React from 'react';
import './Card.scss'
import CardInfo from './Cardinfo'


const Card = (props) => {

    return (
        <div className="d-inline-block g-card " >
            <div >
                <img className="g-card-img img-crop " src={props.item.imgSrc} alt={props.item.imgSrc} />
                <CardInfo title={props.item.title} subTitle={props.item.subTitle} category={props.item.category} />
            </div>
        </div>
    );
}

export default Card;